<!--门店信息-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">门店信息</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container4" style="margin-top: 0px;margin-left: 30px; margin-right: 30px;">
        <el-row style="width: 90%;">
          <el-col :span="12">
            <el-row class="row-s">
            <span class="outlet-txt">
              {{storeFront.title}}
            </span>
              <br>
            </el-row>
            <el-row class="row-s">
              <el-col :span="24">
                <div class="row-padd">
                  门店体验课是否可以预约等级课:&nbsp;&nbsp;&nbsp;<el-radio-group v-model="storeFront.levelFlag">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                门店订单成单人1的金额占比&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.firstSale" :precision="2"
                                                                :step="0.1" :max="100"></el-input-number>
              </div>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                未到签到<el-input-number v-model="storeFront.notAttendSignDay" :precision="0"
                                                      :step="1" ></el-input-number>天内课程可以预约
              </div>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                门店标签&nbsp;&nbsp;&nbsp;<el-select v-model="storeFront.selectTagIds" multiple :multiple-limit="4"
                                                 placeholder="请选择">
                <el-option
                        v-for="item in tagList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
              </div>
            </el-row>
            <el-row class="row-s">
              <div v-if="false">
                <i style="color: #0d6fb8;font-size: 20px;" class="el-icon-map-location"></i>
                <span class="outlet-txt-2">
            {{storeFront.province}}  {{storeFront.city}}   {{storeFront.area}}
            {{storeFront.detailAddress}}
          </span>
              </div>
            </el-row>
            <el-row class="row-s">
              <div>
                <i style="color: #0d6fb8;font-size: 20px;" class="el-icon-phone-outline"></i>
                <span class="outlet-txt-2">
            {{storeFront.tel}} ( {{storeFront.time}})
          </span>
              </div>
            </el-row>
            <el-row class="row-s">
              <div v-if="false" id="map-container"
                   style="width: 50%; height: 560px;margin-top: 20px; margin-bottom: 30px;"></div>
            </el-row>
            <el-row class="row-s">
              <span class="outlet-txt-2">
                小程序预约规则
              </span>
            </el-row>
            <el-row class="row-s">
              <el-col :span="24">
                <div class="row-padd">
                  预约规则:&nbsp;&nbsp;&nbsp;<el-radio-group v-model="storeFront.appointmentRule">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                上课前&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.appointmentTime" :precision="0"
                                                                :step="1" ></el-input-number>小时内不能预约
              </div>
            </el-row>
            <el-row class="row-s">
              <el-col :span="24">
                <div class="row-padd">
                  取消规则:&nbsp;&nbsp;&nbsp;<el-radio-group v-model="storeFront.cancelRule">
                  <el-radio :label="true">允许</el-radio>
                  <el-radio :label="false">不允许</el-radio>
                </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                上课前&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.cancelTime" :precision="0"
                                                      :step="1" ></el-input-number>小时内不可以取消
              </div>
            </el-row>
            <el-row class="row-s">
              <span class="outlet-txt-2">
                签到设置
              </span>
            </el-row>
            <el-row class="row-s">
              <el-col :span="24">
                <div class="row-padd">
                  是否启用签到设置:&nbsp;&nbsp;&nbsp;<el-radio-group v-model="storeFront.signSettings">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                上课前&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.signBeforeTime" :precision="0"
                                                      :step="1" ></el-input-number>小时可以签到
              </div>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                上课后&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.signAfterTime" :precision="0"
                                                      :step="1" ></el-input-number>小时可以签到
              </div>
            </el-row>

            <el-row class="row-s">
              <div class="btn-padd">
                <el-button type="primary" size="medium" class="operator-btn" @click="updateSetting()">更新配置</el-button>
              </div>
            </el-row>
          </el-col>
          <el-col :span="12" >
            <el-row>
              <span class="outlet-txt-2">
              客服电话:15056623096
              </span>
            </el-row>
            <el-row>
              <span class="outlet-txt-2">
                客服微信:
              </span>
            </el-row>
            <el-row>
              <el-image style ="width:200px; height: 200px" src="https://oss.mssbaby.com/icon/lianxiwo.png"></el-image>
            </el-row>
            <el-row style="padding-top: 30px;"></el-row>
            <el-row class="row-s">
              <div class="row-padd">
                基础游剩余课时阀值&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.baseSurplusHours" :precision="0"
                                                            :step="1" ></el-input-number>课时
              </div>
            </el-row>
            <el-row class="row-s">
              <div class="row-padd">
                亲子游剩余课时阀值&nbsp;&nbsp;&nbsp;<el-input-number v-model="storeFront.parentingSurplusHours" :precision="0"
                                                            :step="1" ></el-input-number>课时
              </div>
            </el-row>
            <el-row class="row-s">
              <el-upload
                :action="uploadAction"
                :headers="importHeaders"
                :on-success="handleUploadSuccess"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :limit=1
                list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传png文件</div>
              </el-upload>
            </el-row>
          </el-col>
        </el-row>


      </div>
    </el-card>

  </div>
</template>

<style scoped>
  .row-s{
    text-align-last:left;
    width: 80%;
  }
  .outlet-txt{
    font-size: 36px;
    line-height: 60px;
    text-align: center;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
    margin-top: 10px;
  }
  .outlet-txt-2{
       font-size: 18px;
       line-height: 45px;
       text-align: center;
       background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
       -webkit-background-clip:text;
       -webkit-text-fill-color:transparent;
     }
  .outlet-txt-3{
    font-size: 18px;
    line-height: 45px;
    text-align: center;
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .btn-padd{
    padding-bottom: 10px
  }
  .row-padd{
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: medium;
  }
</style>

<script>

  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {findStoreById,updateSetting} from "../../../api/storeFront";
  import {tagList,} from "../../../api/storeFrontTag";
  import {TMap} from "../../../utils/TMap";
  import { getToken } from '@/utils/auth'
  import messageUtils from "@/utils/messageUtils";

  export default {

    data() {
      return {
        storeFront: {},
        map: null,
        key: 'ZYHBZ-5QRRW-O5VR3-RKPDT-P4E4K-O6BJI',
        tagList:[],
        uploadAction:process.env.BASE_API  + '/upload/common/uploadImage',
        importHeaders:{},
        fileList:[]
      }
    },
    created(){
      let mytoken = getToken();
      this.importHeaders  = {"Authorization": mytoken}
      this.init();
    },
    mounted() {
    },
    methods: {
      beforeAvatarUpload(file) {
        console.log(file,'file')
        const isPNG = file.type === "image/png";
        // const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isPNG) {
          this.$message.error('上传图片只能是 PNG 格式!');
        }
        // if (!isLt2M) {
        //   this.$message.error('上传图片大小不能超过 2MB!');
        // }
        return isPNG;
        // return isJPG && isLt2M;
      },
      handleUploadSuccess(res, file){
        console.log(res)
        if(res.code != 20000){
          messageUtils.errorMsg(this,res.message)
          return
        }
        messageUtils.successMsg(this,"上传成功");
        this.storeFront.watermark = res.data
      },
      init(){
        let param = {id:globaldata.getAdminStore().storeFrontId,}
        findStoreById(param).then(response => {
          let data = response.data;
          console.log(data)
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.storeFront =data;
          this.mapInit(data.longitude, data.latitude, 16);
          if(commonUtils.isStringNull(this.storeFront.watermark) == false){
            this.fileList.push({
              url:this.storeFront.watermark
            })
          }
          if (commonUtils.isStringNull(this.storeFront.bussnessTime) ==false){
            let timearr  = this.storeFront.bussnessTime.split('_')
            this.storeFront.time = timearr[0] + " 至 " + timearr[1];
            // this.storeFront.time = JSON.parse(timearr[0]) + " 至 " +JSON.parse(timearr[1]);
          }
          if (commonUtils.isStringNull(this.storeFront.picUrls) ==false){
            this.storeFront.imageList = JSON.parse(this.storeFront.picUrls);
          }
        })
        let tagQueryParam = {
          "pageNum":1,
          "pageSize":200,
        }
        tagList(tagQueryParam).then(response => {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.tagList = data.records
        })
      },
      updateSetting(){
        this.$confirm('是否确认更新配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            id:globaldata.getAdminStore().storeFrontId,
            shopFrontId:globaldata.getAdminStore().storeFrontId,
            levelFlag:this.storeFront.levelFlag,
            firstSale:this.storeFront.firstSale,
            selectTagIds:this.storeFront.selectTagIds,
            appointmentRule:this.storeFront.appointmentRule,
            appointmentTime:this.storeFront.appointmentTime,
            cancelRule:this.storeFront.cancelRule,
            cancelTime:this.storeFront.cancelTime,
            signSettings:this.storeFront.signSettings,
            signBeforeTime:this.storeFront.signBeforeTime,
            signAfterTime:this.storeFront.signAfterTime,
            notAttendSignDay:this.storeFront.notAttendSignDay,
            baseSurplusHours:this.storeFront.baseSurplusHours,
            parentingSurplusHours:this.storeFront.parentingSurplusHours,
            watermark:this.storeFront.watermark
          }
          updateSetting(param).then(response => {
            let data = response.data;
            if (response.code === 20000){
              this.$message({
              type: 'success',
              message: '更新成功'
            });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新'
          });
        });
      },

      /**
       * 根据传入的值渲染地图及传出经纬度和地名
       * @param lng 经度
       * @param lat 纬度
       * @param zoom 地图缩放级别
       */
      mapInit(lng, lat, zoom) {
        console.log(lng)
        console.log(lat)
        TMap(this.key).then(qq => {
          let that = this;
          let center = new qq.maps.LatLng(lat, lng);
          that.map = new qq.maps.Map(document.getElementById("map-container"), {
            // 地图的中心地理坐标
            center: center,
            //初始化地图缩放级别
            zoom: zoom
          });
          let marker = new qq.maps.Marker({
            position: center,
            map: that.map,
          })
        });
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/store-info/index.vue